// extracted by mini-css-extract-plugin
module.exports = {"modal_footer":"medewerkers_modal_footer__2i11Y","remove_overflow":"medewerkers_remove_overflow__1oaZo","loading_indicator":"medewerkers_loading_indicator__GE6rx"};